module.exports = __webpack_public_path__ + "img/13c-doc-emissao-irregularidades.5f307eb0.png";